import { map, chain, tap, filter, startWith, concat, continueWith, concatMap, transduce, slice, take, skip, takeWhile, skipWhile, skipAfter, until, since, during, loop, reduce, observe, delay, recoverWith, merge, combine } from 'most';
import { curryN } from 'ramda';

var curry2 = curryN(2);
var curry3 = curryN(3);

var map$1 = curry2(map);
var chain$1 = curry2(chain);
var tap$1 = curry2(tap);
var filter$1 = curry2(filter);
var startWith$1 = curry2(startWith);
var concat$1 = curry2(concat);
var continueWith$1 = curry2(continueWith);
var concatMap$1 = curry2(concatMap);
var transduce$1 = curry2(transduce);
var slice$1 = curry3(slice);
var take$1 = curry2(take);
var skip$1 = curry2(skip);
var takeWhile$1 = curry2(takeWhile);
var skipWhile$1 = curry2(skipWhile);
var skipAfter$1 = curry2(skipAfter);
var until$1 = curry2(until);
var since$1 = curry2(since);
var during$1 = curry2(during);
var loop$1 = curry3(loop);
var reduce$1 = curry3(reduce);
var observe$1 = curry2(observe);
var delay$1 = curry2(delay);
var recoverWith$1 = curry2(recoverWith);
var merge$1 = curry2(merge);
var combine$1 = curry2(combine);

export { map$1 as map, chain$1 as chain, tap$1 as tap, filter$1 as filter, startWith$1 as startWith, concat$1 as concat, continueWith$1 as continueWith, concatMap$1 as concatMap, transduce$1 as transduce, slice$1 as slice, take$1 as take, skip$1 as skip, takeWhile$1 as takeWhile, skipWhile$1 as skipWhile, skipAfter$1 as skipAfter, until$1 as until, since$1 as since, during$1 as during, loop$1 as loop, reduce$1 as reduce, observe$1 as observe, delay$1 as delay, recoverWith$1 as recoverWith, merge$1 as merge, combine$1 as combine };
